/**
 * Dependency imports
 */
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Text, TextProps } from '@mantine/core';

/**
 * Local imports
 */

/**
 * Root
 */
const Root = styled(Text, {
  shouldForwardProp: (prop: PropertyKey) => ![''].includes(prop.toString()),
})<Partial<HighlightedTextCombinedProps>>(
  (props) => css`
    position: relative;
    display: inline-block;
    z-index: 0;

    &:before {
      content: '';
      position: absolute;
      top: 40%;
      left: -4%;
      width: 108%;
      height: 45%;
      opacity: 0.25;
      background-color: var(--color-primary);
      z-index: -1;
    }
  `
);

/**
 * HighlightedText Component
 */
export interface HighlightedTextProps {
  children: React.ReactNode;
}

export type HighlightedTextCombinedProps = HighlightedTextProps & TextProps;

const HighlightedText: React.FC<HighlightedTextCombinedProps> = ({
  ...props
}) => {
  return <Root fz={16} fw={500} {...props} />;
};

export default HighlightedText;
